import { AIPosture } from '@/gen/inventory/v1/ai_posture_pb'

import type { BadgeProps } from '@/components/lemmala-design-system/badge/badge'

type AIPostureBadgeVariant = {
  variant: BadgeProps['variant']
  badgeStyle: BadgeProps['badgeStyle']
  className?: string
}

const baseAiPostureBadgeVariant: Record<AIPosture, AIPostureBadgeVariant> = {
  [AIPosture.AI_POSTURE_MODEL_PROVIDER]: {
    variant: 'promotion',
    badgeStyle: 'subtle',
  },
  [AIPosture.AI_POSTURE_AI_NATIVE]: {
    variant: 'ai',
    badgeStyle: 'subtle',
  },
  [AIPosture.AI_POSTURE_EMBEDDED_AI]: {
    variant: 'neutral',
    badgeStyle: 'ghost',
  },
  [AIPosture.AI_POSTURE_NON_AI]: {
    variant: 'neutral',
    badgeStyle: 'ghost',
    className: 'text-main-foreground-placeholder',
  },
  [AIPosture.AI_POSTURE_UNSPECIFIED]: {
    variant: 'neutral',
    badgeStyle: 'ghost',
    className: 'text-main-foreground-placeholder',
  },
}

// EMBEDDED_AI reads as Neutral Subtle in standalone badge contexts (drawers, cells)
// but stays Neutral Ghost inside the dedicated AI Posture column so the column
// cell doesn't compete with the row's other badges.
const badgeAiPostureVariant: Record<AIPosture, AIPostureBadgeVariant> = {
  ...baseAiPostureBadgeVariant,
  [AIPosture.AI_POSTURE_EMBEDDED_AI]: {
    variant: 'neutral',
    badgeStyle: 'subtle',
  },
}

export const aiPostureBadgeVariantByDisplay = {
  badge: badgeAiPostureVariant,
  column: baseAiPostureBadgeVariant,
}
